import styled from 'styled-components';

const ModalContent = styled.div`
   margin: 0 auto;
   width: var(--modal-content-width);
   font-family: var(--content-font);

   h1 {
      font-family: var(--heading-font);
      font-size: 1.4em;
      margin-bottom: 1.5em;
      text-align: center;
   }

   .modal-p {
      font-size: 1.25em;
      margin-bottom: 1.5em;
      line-height: 1.4;
   }

   .modal-button-wrapper {
      text-align: center;
   }

   .modal-button-wrapper-with-dismiss {
      margin: 1.5em auto 0;
      display: grid;
      grid-gap: 0.5em;
      width: min(100%, 13em);

      .button-dismiss {
         margin-top: 1em;
         padding: 0;
         font-size: 0.9em;
      }
   }

   .modal-signup-logo {
      display: block;
      margin: 0 auto 2em;
      width: 125px;
      position: relative;
   }
`;

export { ModalContent };
